const PlayerVolumeControlHandler = require("./PlayerVolumeControlHandler");
const WebSerialVolumeControlHandler = require("./WebSerialVolumeControlHandler");

const ConfigurationFactory = require("../ConfigurationFactory");
const Logger = require("../Logger");

const UNKNOWN_ERROR_CODE = "E999999999";

const service = {};

service.configure = ( volumeControlSupported, volumePercentage, player ) => {
  if (ConfigurationFactory.isChromeOsPwaPlayerExtensionAvailable()) {
    return WebSerialVolumeControlHandler.configure( volumeControlSupported, volumePercentage );
  }

  return PlayerVolumeControlHandler.configure( volumeControlSupported, volumePercentage, player );
}

service.setVolumeLevelToAlert = () => {
  if (ConfigurationFactory.isChromeOsPwaPlayerExtensionAvailable()) {
    return WebSerialVolumeControlHandler.setVolumeLevelToAlert();
  }

  return PlayerVolumeControlHandler.setVolumeLevelToAlert();
}

service.setVolumeLevelToDefault = () => {
  if (ConfigurationFactory.isChromeOsPwaPlayerExtensionAvailable()) {
    return WebSerialVolumeControlHandler.setVolumeLevelToDefault();
  }

  return PlayerVolumeControlHandler.setVolumeLevelToDefault();
}

service.notifyCurrentVolumeLevel = currentVolumeLevel => {
  if (ConfigurationFactory.isChromeOsPwaPlayerExtensionAvailable()) {
    Logger.viewerError( UNKNOWN_ERROR_CODE, "Volume level callbacks are not used on this player type" );

    return;
  }

  PlayerVolumeControlHandler.notifyCurrentVolumeLevel( currentVolumeLevel );
}

service.notifyCurrentVolumeLevelReadError = errorMessage => {
  if (ConfigurationFactory.isChromeOsPwaPlayerExtensionAvailable()) {
    Logger.viewerError( UNKNOWN_ERROR_CODE, "Volume level callbacks are not used on this player type" );

    return;
  }

  PlayerVolumeControlHandler.notifyCurrentVolumeLevelReadError( errorMessage );
}

module.exports = service;
